module.exports = __webpack_public_path__ + "static/media/icon-edit.e1f09833.svg";